import { api } from "shared/config/api/api";
import { TICKETS_LIST_TAG, ticketTag } from "entities/support-ticket";
import type {
  ReplyTicketRequest,
  SupportTicketDetail,
} from "entities/support-ticket";

export const replyTicketApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Ответ меняет статус (answered → in_progress): обновляем список
    // и inbox, где статус лежит в action.data.ticket_status.
    replyTicket: builder.mutation<SupportTicketDetail, ReplyTicketRequest>({
      query: ({ ticketId, body }) => ({
        url: `/support/tickets/${ticketId}/messages`,
        method: "POST",
        body: { body },
      }),
      invalidatesTags: (_result, _error, { ticketId }) => [
        ticketTag(ticketId),
        TICKETS_LIST_TAG,
        "Notifications",
      ],
    }),
  }),
});

export const { useReplyTicketMutation } = replyTicketApi;
